/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import CountdownRoot from '../countdown/countdown-root';
import focus from '../focus/focus-directive';
import template from './setup-failure.html';

export default {
  name: 'SetupFailure',
  template,
  components: { CountdownRoot },
  directives: { focus },
  methods: {
    onBack() {
      this.$emit('back');
    },
    onEnd() {
      this.retry();
    },
    onRetry() {
      this.retry();
    },
    retry() {
      this.$emit('retry');
    }
  },
  props: ['message', 'retryTime']
};
